export interface Phone {
    label: string
    value: string
}

export interface ContactsPerson {
    pictureURL?: string
    role: string
    name: string
    phone: Phone
    email: string
}

export interface ContactsCompany {
    pictureURL?: string
    name: string
    street: string
    city: string
    country: string
    nip: string
    website: string
    phone: Phone
    email: string
}

export interface ContactsPage {
    persons: ContactsPerson[]
    companies: ContactsCompany[]
}

export var machineRentPageContacts: ContactsPage = {
    persons: [{
        name: 'Žygimantas Kristutis',
        role: 'Rental/sales',
        phone: {
            label: '+37 065 579 364',
            value: '+37065579364'
        },
        email: 'zygimantas.kristutis@wsy.lt'
    }, {
        name: 'Kęstutis Grigalevičius',
        role: 'Service',
        phone: {
            label: '+37 068 050 003',
            value: '+37068050003'
        },
        email: 'kestutis.grigalevicius@wsy.lt'
    }],
    companies: []
}

export var machineBuyPageContacts: ContactsPage = machineRentPageContacts

export var callPageContacts: ContactsPage = machineRentPageContacts

export var supportPageContacts: ContactsPage = {
    persons: [{
        pictureURL: '/public/env/img/contact/marcin-skibinski.png',
        name: 'Marcin Skibiński',
        role: 'Super Administrator',
        phone: {
            label: '+48 519 343 232',
            value: '+48519343232'
        },
        email: 'marcin@evoltag.pl'
    }],
    companies: []
}